import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Snackbar,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { del, get, get_pdf } from "../../Services/tokenConfig";
import LoadingVulpes from "../../Styles/Loader/loading";
import { func_print } from "../../Func_genericas/func_print";
import { AuthContext } from "../../AuthContext/AuthContext";
import { Modalshowpdf } from "../../Components/VerPdf/modal_show_pdf";
import DeleteIcon from '@mui/icons-material/Delete';
import { Alert } from "../../Components/Alert/Alert";


interface IHistorico {
  id_caderno: number;
  cultura_caderno: string;
  ano: number;
  link: string;
  publico: boolean;
  id_rosto: number;
  create_date: string;
  last_update: string;
  uuid: string;
}

export default function Historico(params: any) {
  const navigate = useNavigate();
  const auth = React.useContext(AuthContext);

  const [isloading, setIsLoading] = useState(true);
  const [listHistorico, setListHistorico] = useState<IHistorico[]>([]);
  const [link, setLink] = useState("");
  const [open_modal_show_pdf, set_open_modal_show_pdf] = React.useState<boolean>(false);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = useState("");

  const getHistoric = async () => {
    try {

      let res = await get(auth.token.cookie_token, `/get_historico_idAgri/${params.idagri}`);
      if (res.status === 200) {
        setListHistorico(res.data.result);
        setLink(res.data.result[0].link);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      func_print("getHistoric", error, true);
    }
  };

  const cadernoAtivo = async (id: number) => {
    try {
      setIsLoading(true);

      let res = await get(auth.token.cookie_token, `/get_rosto_id/${id}`);
      auth.func_set_is_historico({
        id_rosto: id,
        is_historico: true
      })
      navigate("/IdentificacaoBenExp",
        {
          state: {
            ...res.data.result,
            is_historico_real_flag: true
          },
        });
      setIsLoading(false);

    } catch (error) {
      setIsLoading(false);
      func_print("getHistoric", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);

    }
  };

  // const showpdf = async (link: string) => {
  //   try {

  //     if (link.length !== 0) {
  //       setLink(link)

  //       set_open_modal_show_pdf(true)

  //     }
  //   } catch (error) {
  //     func_print('handler_open_pdf', error, true)

  //   }
  // };


  const delete_caderno = async (id_caderno_to_delete: number) => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token, `/delete_historico/${id_caderno_to_delete}`);
      if (res.status === 200) {

        let lista_aux = listHistorico.filter((el) => {
          if (el.id_caderno !== id_caderno_to_delete) {
            return el
          }
        })
        if (lista_aux !== undefined) {
          setListHistorico(lista_aux);
          setLink(lista_aux[0].link);
        } else {
          setListHistorico([]);
          setLink('');
        }

      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      func_print("delete_caderno", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);
    }
  };

  const baixar_caderno = async (id_rosto: number, cultura: string, ano: number) => {
    try {
      setIsLoading(true);

      let res = await get_pdf(auth.token.cookie_token, `/pdf/gerar/${id_rosto}`, { responseType: 'blob' });
      if (res.status === 200) {

        const file = new Blob([res.data], {
          type: "application/pdf",
        });

        // Criar URL temporária
        const fileURL = window.URL.createObjectURL(file);

        // Criar link para download
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = cultura + '_' + ano + ".pdf"; // nome do ficheiro
        link.click();

        // Limpar URL depois
        window.URL.revokeObjectURL(fileURL);

      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      func_print("delete_caderno", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);
    }
  };


  useEffect(() => {
    (async () => {
      await getHistoric();
    })();
  }, []);

  return (
    <TableBody>
      <Snackbar
        open={openSnackSuccess}
        autoHideDuration={2000}
        onClose={() => setOpenSnackSuccess(false)}
      >
        <Alert
          onClose={() => setOpenSnackSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackError}
        autoHideDuration={2000}
        onClose={() => setOpenSnackError(false)}
      >
        <Alert
          onClose={() => setOpenSnackError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}

        </Alert>
      </Snackbar>
      {isloading ? (
        <TableRow>
          <TableCell colSpan={2} align="center">
            <LoadingVulpes />
          </TableCell>
        </TableRow>
      ) : (
        <>
          <Modalshowpdf open_modal_show_pdf={open_modal_show_pdf}
            set_open_modal_show_pdf={set_open_modal_show_pdf}
            link_file={link}
          ></Modalshowpdf>
          <TableRow>
            <TableCell>
              <Typography fontWeight={600} fontSize={18} align="center" sx={{ fontFamily: "candara" }}>
                Ano
              </Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight={600} fontSize={18} align="center" sx={{ fontFamily: "candara" }}>
                Cultura
              </Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight={600} fontSize={18} align="center" sx={{ fontFamily: "candara" }}>
                Ações
              </Typography>
            </TableCell>
          </TableRow>

          {listHistorico.length > 0 ? (
            listHistorico.map((lista, i) => (
              <TableRow key={i}>
                <TableCell>
                  <Typography fontWeight={600} fontSize={16} sx={{ marginLeft: "20px" }}>
                    {lista.ano}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography fontWeight={600} fontSize={16} sx={{ marginLeft: "20px" }}>
                    {lista.cultura_caderno}
                  </Typography>
                </TableCell>
                <TableCell align="right">

                  <IconButton aria-label="View" onClick={() => { cadernoAtivo(lista.id_rosto) }}>
                    <VisibilityIcon sx={{ height: 27, width: 27 }} />
                  </IconButton>
                  <IconButton aria-label="Download" onClick={() => baixar_caderno(lista.id_rosto, lista.cultura_caderno, lista.ano)}>
                    {/* <IconButton aria-label="Download" onClick={() => showpdf(lista.link)}> */}
                    <FileDownloadIcon sx={{ height: 27, width: 27 }} />
                  </IconButton>

                  {

                    lista.publico === false ?
                      <IconButton aria-label="View" onClick={() => { delete_caderno(lista.id_caderno) }}>
                        <DeleteIcon sx={{ height: 27, width: 27 }} />
                      </IconButton>
                      : <></>}
                  {/* <IconButton aria-label="View" onClick={() => { delete_caderno(lista.id_caderno) }}>
                    <DeleteIcon sx={{ height: 27, width: 27 }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="center">
                <Typography fontWeight={400} fontSize={20} color="#C94F1E">
                  Histórico Vazio
                </Typography>
              </TableCell>
            </TableRow>
          )}


        </>
      )}
    </TableBody>
  );
}